export default {
  registerAuditEdit: {
    component: () =>
      import(
        /* webpackChunkName: "system_detail" */ "@/mods/system/registerAudit/detailView/RegisterAuditEdit"
      ),
  },
};
